import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

function Logo() {
  const navigate = useNavigate();

  return (
    <Root className="flex items-center">
      {/* <p>QR Code</p> */}
      <img className="w-full max-w-160 cursor" src="assets/images/logo/logo.png" alt="logo"   onClick={() => navigate('/dashboard')} />
    </Root>
  );
}

export default Logo;
